import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Place } from './place.interface';
import { PlaceService } from './place.service';

const service = new PlaceService();

export interface PlaceState {
   places: Array<Place>;
}

const CityStore: Module<PlaceState, StoreState> = {
   namespaced: true,
   state: {
      places: [],
   },
   getters: {},
   mutations: {},
   actions: {
      async getPlaces(context, placeId: string) {
         return await service.getPlaces(placeId);
      },
   },
};

export default CityStore;
